import { marker as bitfToTranslate } from '@biesbjerg/ngx-translate-extract-marker';

export enum ERefundType {
  COUPON = 'coupon',
  REFUND = 'refund',
}

bitfToTranslate('RETURNS.REFUND_TYPE_COUPON');
bitfToTranslate('RETURNS.REFUND_TYPE_REFUND');
